<ng-container *ngIf="text$ | async as text">
  <ng-container *ngIf="{groups: (slideViewerFacade.currentSelectedSlideGroups$ | async), themeColor: (slideViewerFacade.themeColor$ | async)} as data">
    <div #textElement (click)="onLinkClick($event)" (mouseout)="onLinkOut($event)" (mouseover)="onLinkOver($event)">
      <medsurf-text-format [text]="test$ | async"></medsurf-text-format>
    </div>
  </ng-container>
</ng-container>


